import { render, staticRenderFns } from "./BetslipHeader.vue?vue&type=template&id=07880604&scoped=true"
import script from "./BetslipHeader.vue?vue&type=script&lang=js"
export * from "./BetslipHeader.vue?vue&type=script&lang=js"
import style0 from "./BetslipHeader.vue?vue&type=style&index=0&id=07880604&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07880604",
  null
  
)

export default component.exports